import { render, staticRenderFns } from "./AnimalWeightRecord.AutomaticPanel.vue?vue&type=template&id=4f79503c&scoped=true&"
import script from "./AnimalWeightRecord.AutomaticPanel.vue?vue&type=script&lang=js&"
export * from "./AnimalWeightRecord.AutomaticPanel.vue?vue&type=script&lang=js&"
import style0 from "./AnimalWeightRecord.AutomaticPanel.vue?vue&type=style&index=0&id=4f79503c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f79503c",
  null
  
)

export default component.exports